<script lang="ts" setup>
import type { Task } from '~/models/AssignTask'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { PendoFeature } from '~/models/Pendo'
import { useAssignTask } from '~/composables/useAssignTask'
import Button from '~/components/ui/Button.vue'
import AuSpinner from '~/components/ui/AuSpinner.vue'
import AuDialog from '~/components/ui/AuDialog.vue'

const { task, disableBtn = false } = defineProps<{ task: Task, disableBtn?: boolean }>()

const { t } = useI18n()
const { deleteTask } = useAssignTask()

const open = ref(false)
</script>

<template>
  <AuDialog
    v-model:open="open"
    :description="t('assign.deleteConfirm', { name: task.name })"
    :title="task.name ?? ''"
  >
    <template #trigger>
      <Button
        :disabled="disableBtn"
        class="mr-auto"
        color="coral"
        size="lg"
        variant="ghost"
        @click="open = true"
      >
        {{ t('assign.delete') }}
      </Button>
    </template>
    <template #content>
      <div class="mt-6 grid grid-cols-2 gap-2">
        <Button
          :disabled="deleteTask.isPending.value"
          center
          color="gray"
          size="lg"
          variant="outline"
          @click="open = false"
        >
          {{ t('cancel') }}
        </Button>
        <Button
          :data-pendo="PendoFeature.TermExam.DeleteTask"
          :disabled="deleteTask.isPending.value"
          center
          color="coral"
          size="lg"
          @click="deleteTask.mutateAsync(task)"
        >
          <div class="flex gap-1">
            {{ deleteTask.isPending.value ? t('assign.deletingExam') : t('assign.deleteExam') }}
            <AuSpinner
              v-if="deleteTask.isPending.value"
              size="sm"
              color="var(--color-seagreen-30)"
            />
          </div>
        </Button>
      </div>
    </template>
  </AuDialog>
</template>
